import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
} from "@angular/core";
import Chart from "chart.js";
import { merge } from "lodash";

@Component({
  selector: "ab-stacked-bar-chart",
  templateUrl: "./stacked-bar-chart.component.html",
})
export class StackedBarChartComponent implements AfterViewInit, OnChanges {
  public chart: Chart;
  @Input() private config: any;
  private DEFAULT_OPTIONS = {
    scales: {
      xAxes: [
        {
          stacked: true,
        },
      ],
      yAxes: [
        {
          stacked: true,
        },
      ],
    },
  };
  private canvasEl: HTMLCanvasElement;
  private nativeEl: HTMLElement;

  constructor(element: ElementRef) {
    this.nativeEl = element.nativeElement;
  }

  public ngAfterViewInit() {
    this.canvasEl = this.nativeEl.querySelector("canvas");
    this.renderChart();
  }

  public ngOnChanges() {
    this.renderChart();
  }

  private renderChart() {
    if (this.config == null || this.canvasEl == null) {
      return;
    }

    if (this.chart == null) {
      this.chart = new Chart(this.canvasEl, {
        type: "bar",
        data: this.config.data,
        options: this.configOptions(this.config.options),
      });
    } else {
      this.chart.data = this.config.data;
      this.chart.options = this.configOptions(this.config.options);
      this.chart.update();
    }
  }

  private configOptions(options: any = {}) {
    return merge({}, this.DEFAULT_OPTIONS, options);
  }
}
